export default "__VITE_ASSET__UOXFl7Pr__"